import { render, staticRenderFns } from "./deanSectionTitle.vue?vue&type=template&id=1c916cb8&scoped=true"
import script from "./deanSectionTitle.vue?vue&type=script&lang=ts"
export * from "./deanSectionTitle.vue?vue&type=script&lang=ts"
import style0 from "./deanSectionTitle.vue?vue&type=style&index=0&id=1c916cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c916cb8",
  null
  
)

export default component.exports